import { Directive, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[InputTrim]'
})
export class InputTrimDirective {
    @Input() InputTrim: string;
    @Output() updateValue: EventEmitter < any > = new EventEmitter();

    constructor(private el: ElementRef) { }

    @HostListener("input")
    onInput() {
        // for input elements
        if (this.el.nativeElement.value) {
            this.el.nativeElement.value = this.el.nativeElement.value.split(" ").join("");
            this.updateValue.emit(this.el.nativeElement.value);
        }
        // for mdl-textfield input elements
        else if (this.el.nativeElement.children[0].children[0].value) {
            this.el.nativeElement.children[0].children[0].value = this.el.nativeElement.children[0].children[0].value.split(" ").join("");
            this.updateValue.emit(this.el.nativeElement.children[0].children[0].value);
        }
    }

    ngOnInit() {
    }
}